import {
	servicePageConstants
} from './servicePage.constants';
import {
	servicePageService
} from 'services';

export const servicePageActions = {
	sendService
};

function sendService(payload) {
	return (dispatch) => {
		dispatch(request());
		return servicePageService.sendService(payload)
			.then(
				result => {
					dispatch(success())
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error))
					return Promise.reject(error);
				}
			);
	};

	function request() {
		return {
			type: servicePageConstants.SEND_SERVICE_PAGE_REQUEST,
		};
	}

	function success() {
		return {
			type: servicePageConstants.SEND_SERVICE_PAGE_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: servicePageConstants.SEND_SERVICE_PAGE_ERROR,
			error,
		};
	}
}